<template>
  <v-card tile flat class="pb-5" :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-card-title class="pb-3 progress">
      <v-img class="mr-3" max-width="16" src="@/assets/Dashboard/git.svg"></v-img>Level Wise Commission
    </v-card-title>
    <div class="progress">
      <v-progress-circular size="150" width="20" v-if="chartSeries <= 0" indeterminate
        color="primary"></v-progress-circular>
    </div>
    <apexcharts class="text-center" type="donut" :width="288" :height="288" :options="chartOptions" :series="chartSeries">
    </apexcharts>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexcharts: VueApexCharts,
  },

  props: {
    stats: {
      type: Object,
      required: true,
    },
  },

  computed: {
    chartOptions: function () {
      return {
        colors: this.generateRandomColors(),
        legend: {
          position: "bottom",
          fontSize: "10px",
          fontFamily: "Inter",
          fontWeight: 400,
          labels: {
            colors: "#708AA7",
          },
          markers: {
            width: 6,
            height: 6,
          },
          itemMargin: {
            horizontal: 5,
          },
        },
        stroke: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        labels:
          this.stats && this.stats.levelWiseCommissions
            ? Object.keys(this.stats.levelWiseCommissions).map(
              (level) => `Level ${level}`
            )
            : [],
      };
    },
    chartSeries: function () {
      return this.stats && this.stats && this.stats.levelWiseCommissions
        ? Object.values(this.stats.levelWiseCommissions)
        : [];
    },
  },

  methods: {
    generateRandomColors: function () {
      const predefinedColors = [
        "#307633",
        "#307676",
        "#436AA6",
        "#FF7BDA",
        "#FF6363",
        "#647630",
        "#7543B5",
        "#0E8CB4",
        "#50E18A",
        "#FFC163",
      ];

      const colors = [];
      const labelsLength =
        this.stats && this.stats.levelWiseCommissions
          ? Object.keys(this.stats.levelWiseCommissions).length
          : 0;

      // Function to generate random hue with a minimum distance between them
      const generateRandomHue = () => Math.floor(Math.random() * 360);

      if (labelsLength <= predefinedColors.length) {
        // Use predefined colors if the data length is within the range
        return predefinedColors.slice(0, labelsLength);
      } else {
        // Generate random colors if the data length exceeds the range
        for (let i = 0; i < labelsLength; i++) {
          let randomHue = generateRandomHue();

          // Ensure the generated hue is sufficiently different from existing hues
          while (colors.some((color) => Math.abs(color.hue - randomHue) < 30)) {
            randomHue = generateRandomHue() + 50;
          }

          // Convert HSL to HEX
          const randomColor = `hsl(${randomHue}, 100%, 50%)`;
          colors.push(randomColor);
        }
        return colors;
      }
    },
  },
};
</script>

<style>
.progress {
  display: flex;
  justify-content: center;
}
</style>
